'use strict';

/**
 * Converts seconds to milliseconds
 *
 * @param seconds - Time in seconds.
 * @return milliseconds - Converted time in milliseconds.
 */
/*#__NO_SIDE_EFFECTS__*/
const secondsToMilliseconds = (seconds) => seconds * 1000;
/*#__NO_SIDE_EFFECTS__*/
const millisecondsToSeconds = (milliseconds) => milliseconds / 1000;

exports.millisecondsToSeconds = millisecondsToSeconds;
exports.secondsToMilliseconds = secondsToMilliseconds;
//# sourceMappingURL=time-conversion.cjs.map
